
function isWeb(device = "WEB") {
    return device === "WEB";
}
function isIOS(device = "WEB") {
    return device === 'IOS';
}

function isAOS(device = "WEB") {
    return device === 'AOS';
}
export const sendMoveMobileSignUp = (device = "WEB") => {
    if(isWeb(device)) return ;
    try {
        if (isIOS(device)) {
            Mutil.mlog("[IOS] sendMoveMobileSignUp");
            return window?.webkit?.messageHandlers?.FLOW_WEB_BRIDGE?.postMessage({ "CODE" : "moveMobileSignUpEvent"});
        }

        if (isAOS(device)) {
            Mutil.mlog("[AOS] sendMoveMobileSignUp");
            return window?.AndroidBridgeSign?.moveMobileSignUpEvent();
        }
    } catch {
        console.error('sendMoveMobileSignUp Send Error');
    }
}

export const sendMoveMobileSignIn = (device = "WEB") => {
    if(isWeb(device)) return ;

     try {
        if (isIOS(device)) {
            Mutil.mlog("[IOS] sendMoveMobileSignIn");
            return window?.webkit.messageHandlers?.FLOW_WEB_BRIDGE?.postMessage({ "CODE" : "moveMobileSignInEvent"});
        }
        if (isAOS(device)) {
            Mutil.mlog("[AOS] sendMoveMobileSignIn");
            return window?.AndroidBridgeSign?.moveMobileSignInEvent();
        }
     } catch(e) {
         console.error('sendMoveMobileSignIn Send Error');
     }
}


export const sendMobileSignIn = (device = "WEB", props) => {
    if(isWeb(device)) return ;
    const {
        ID_GB = "",
        USER_ID = "",
        EMAIL = "",
        USER_NM = "",
        PRFL_PHTG ="",
        SUB_DOM = "",
        PWD = "",
    } = props;
    if(Mutil.empty(ID_GB) || Mutil.empty(USER_ID)) return ;
    const args = { "CODE" : "mobileSignInEvent" , VALUE : { "idGubun"  : ID_GB , "userId" : USER_ID, "userEmail" : EMAIL, "userName" : USER_NM, "userProfilePath" : PRFL_PHTG, "subDomain" : SUB_DOM , "password" : PWD}};
    try {
        if (isIOS(device)) {
            Mutil.mlog("[IOS] mobileSignInEvent");
            return window?.webkit.messageHandlers?.FLOW_WEB_BRIDGE.postMessage(args);
        }

        if (isAOS(device)) {
            Mutil.mlog("[AOS] mobileSignInEvent");
            return window?.AndroidBridgeSign?.mobileSignInEvent(JSON.stringify(args.VALUE));
        }
    } catch {
        console.error('mobileSignInEvent Send Error');
    }
}

export const openMailApp = (device = "WEB", props) => {
    if(isWeb(device)) return ;
    const {
        appName = ""
    } = props;

    if(Mutil.empty(appName)){
        Mutil.mlog("어플리케이션 이름이 없습니다.")
        return ;
    }

    const args = { "CODE" : "openMailApp" , VALUE : {appName }};
    try {
        if (isIOS(device)) {
            Mutil.mlog("[IOS] openMailApp");
            return window?.webkit.messageHandlers?.FLOW_WEB_BRIDGE.postMessage(args);
        }

        if (isAOS(device)) {
            Mutil.mlog("[AOS] openMailApp");
            return window?.AndroidBridgeSign?.openMailApp(JSON.stringify(args.VALUE));
        }
    } catch {
        console.error('openMailApp Send Error');
    }
}

export const openShareContents = (device = "WEB", props) => {
    if(isWeb(device)) return ;
    const {
        text = "",
        title = "",
    } = props;

    const args = { "CODE" : "openShareContents" , VALUE : {body : text,  title }};
    try {
        if (isAOS(device)) {
            Mutil.mlog("[AOS] openShareContents");
            return window?.AndroidBridgeSign?.openShareContents(JSON.stringify(args.VALUE));
        }
    } catch {
        console.error('openShareContents Send Error');
    }
}